import { Link } from 'react-router-dom'

import { env } from 'src/config/env'
import { cn } from 'src/shared/utils/cn'

interface StartJourneyDisclaimerProps {
  className?: string
}

export default function StartJourneyDisclaimer({ className }: StartJourneyDisclaimerProps) {
  return (
    <p
      className={cn(
        'mx-auto max-w-[278px] rounded-[15px] text-center text-[11px] leading-[1.6] text-muted xs:text-[13px]',
        className,
      )}
    >
      By clicking “Start my journey”, you accept our{' '}
      <Link to={env.LINK_TO_TERMS_OF_USE} target="_blank" className="underline">
        Terms and Conditions
      </Link>{' '}
      and{' '}
      <Link to={env.LINK_TO_PRIVACY_POLICY} target="_blank" className="underline">
        Privacy Policy
      </Link>
      .
    </p>
  )
}
